import { Component, EventEmitter, Inject, Injectable, Input, NgModule, Output, PLATFORM_ID, Renderer2, ViewChild } from '@angular/core';
import { CommonModule, isPlatformServer } from '@angular/common';
import { isNullOrUndefined, isUndefined } from 'util';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';

const _c0 = ["container"];
const _c1 = ["prevArrow"];
const _c2 = ["nextArrow"];
const _c3 = function (a0, a1, a2, a3) { return { "background-image": a0, "background-size": a1, "background-position": a2, "background-repeat": a3 }; };
function SlideshowComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 10);
} if (rf & 2) {
    const slide_r5 = ctx.$implicit;
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("selected", slide_r5.selected)("hide-slide", !slide_r5.selected && !slide_r5.leftSide && !slide_r5.rightSide)("left-side", slide_r5.leftSide)("right-side", slide_r5.rightSide)("slide-in-left", slide_r5.action === "slideInLeft")("slide-in-right", slide_r5.action === "slideInRight")("slide-out-left", slide_r5.action === "slideOutLeft")("slide-out-right", slide_r5.action === "slideOutRight");
    ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction4(17, _c3, "url(" + slide_r5.url + ")", ctx_r1.backgroundSize, ctx_r1.backgroundPosition, ctx_r1.backgroundRepeat));
} }
function SlideshowComponent_ul_11_li_1_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 13);
    ɵngcc0.ɵɵlistener("click", function SlideshowComponent_ul_11_li_1_Template_li_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r10); const index_r8 = ctx.index; const ctx_r9 = ɵngcc0.ɵɵnextContext(2); return ctx_r9.onButtonClick(index_r8); });
    ɵngcc0.ɵɵelementStart(1, "button", 14);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const slide_r7 = ctx.$implicit;
    const index_r8 = ctx.index;
    ɵngcc0.ɵɵclassProp("slick-active", slide_r7.selected);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(index_r8);
} }
function SlideshowComponent_ul_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ul", 11);
    ɵngcc0.ɵɵtemplate(1, SlideshowComponent_ul_11_li_1_Template, 3, 3, "li", 12);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r4.slides);
} }
class SwipeService {
    /**
     * \@description detect the direction of the swipe, and return a -1 or 1 if the duration is long enough
     *              else return a 0 to do nothing
     * @param {?} e
     * @param {?} when
     * @param {?=} debug
     * @return {?}
     */
    swipe(e, when, debug) {
        if (debug === true)
            console.log(`SwipeService::swipe(${e}, ${when})`);
        const /** @type {?} */ coord = [e.changedTouches[0].pageX, e.changedTouches[0].pageY];
        const /** @type {?} */ time = new Date().getTime();
        if (when === 'start') {
            this.swipeCoord = coord;
            this.swipeTime = time;
        }
        else if (when === 'end') {
            const /** @type {?} */ direction = [coord[0] - this.swipeCoord[0], coord[1] - this.swipeCoord[1]];
            const /** @type {?} */ duration = time - this.swipeTime;
            if (duration < 1000 // Short enough
                && Math.abs(direction[1]) < Math.abs(direction[0]) // Horizontal enough
                && Math.abs(direction[0]) > 30) {
                return direction[0] < 0 ? 1 : -1;
            }
        }
        return 0;
    }
}
SwipeService.ɵfac = function SwipeService_Factory(t) { return new (t || SwipeService)(); };
SwipeService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: SwipeService, factory: SwipeService.ɵfac });
/**
 * @nocollapse
 */
SwipeService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SwipeService, [{
        type: Injectable
    }], null, null); })();

class SlideshowComponent {
    /**
     * @param {?} swipeService
     * @param {?} renderer
     * @param {?} platform_id
     */
    constructor(swipeService, renderer, platform_id) {
        this.swipeService = swipeService;
        this.renderer = renderer;
        this.platform_id = platform_id;
        this.slideIndex = 0;
        this.slides = [];
        this.initial = true;
        this.showArrows = true;
        this.disableSwiping = false;
        this.autoPlay = false;
        this.autoPlayInterval = 3333;
        this.stopAutoPlayOnSlide = true;
        this.debug = false;
        this.backgroundSize = 'cover';
        this.backgroundPosition = 'center center';
        this.backgroundRepeat = 'no-repeat';
        this.showDots = false;
        this.onSlideLeft = new EventEmitter();
        this.onSlideRight = new EventEmitter();
        this.onSwipeLeft = new EventEmitter();
        this.onSwipeRight = new EventEmitter();
    }
    /**
     * @return {?}
     */
    ngOnChanges() {
        if (this.debug === true)
            console.log(`ngOnChanges()`);
        if (this.initial === true)
            this.urlCache = this.imageUrls;
        this.setSlides();
        this.setStyles();
        this.handleAutoPlay();
    }
    /**
     * \@description this is the function that should be called to make the slides change.
     *              indexDirection to move back is -1, to move forward is 1, and to stay in place is 0.
     *              0 is taken into account for failed swipes
     * @param {?} indexDirection
     * @param {?=} isSwipe
     * @return {?}
     */
    onSlide(indexDirection, isSwipe) {
        if (this.debug === true)
            console.log(`onSlide(${indexDirection}, ${isSwipe})`);
        this.handleAutoPlay(this.stopAutoPlayOnSlide);
        this.slide(indexDirection, isSwipe);
    }
    /**
     * \@description Use the swipe service to detect swipe events from phone and tablets
     * @param {?} e
     * @param {?} when
     * @return {?}
     */
    onSwipe(e, when) {
        if (this.disableSwiping === true)
            return;
        const /** @type {?} */ indexDirection = this.swipeService.swipe(e, when, this.debug === true);
        // handle a failed swipe
        if (indexDirection === 0)
            return;
        else
            this.onSlide(indexDirection, true);
    }
    /**
     * \@description set the index to the desired index - 1 and simulate a right slide
     * @param {?} index
     * @return {?}
     */
    onButtonClick(index) {
        if (this.debug === true)
            console.log(`onButtonClick(${index})`);
        const /** @type {?} */ beforeClickIndex = this.slideIndex;
        this.slideIndex = index - 1;
        this.setSlideIndex(1);
        this.handleAutoPlay(this.stopAutoPlayOnSlide);
        this.slideRight(beforeClickIndex);
        this.slides[beforeClickIndex].selected = false;
        this.slides[this.slideIndex].selected = true;
    }
    /**
     * \@description Set the new slide index, then make the transition happen.
     * @param {?} indexDirection
     * @param {?=} isSwipe
     * @return {?}
     */
    slide(indexDirection, isSwipe) {
        if (this.debug === true)
            console.log(`slide(${indexDirection}, ${isSwipe})`);
        const /** @type {?} */ oldIndex = this.slideIndex;
        this.setSlideIndex(indexDirection);
        if (indexDirection === 1)
            this.slideRight(oldIndex, isSwipe);
        else
            this.slideLeft(oldIndex, isSwipe);
        this.slides[oldIndex].selected = false;
        this.slides[this.slideIndex].selected = true;
    }
    /**
     * \@description This is just treating the url array like a circular list.
     * @param {?} indexDirection
     * @return {?}
     */
    setSlideIndex(indexDirection) {
        if (this.debug === true)
            console.log(`setSlideIndex(${this.slideIndex})`);
        this.slideIndex += indexDirection;
        if (this.slideIndex < 0)
            this.slideIndex = this.slides.length - 1;
        if (this.slideIndex >= this.slides.length)
            this.slideIndex = 0;
    }
    /**
     * \@description This function handles the variables to move the CSS classes around accordingly.
     *              In order to correctly handle animations, the new slide as well as the slides to
     *              the left and right are assigned classes.
     * @param {?} oldIndex
     * @param {?=} isSwipe
     * @return {?}
     */
    slideLeft(oldIndex, isSwipe) {
        if (this.debug === true)
            console.log(`slideLeft(${oldIndex}, ${isSwipe})`);
        if (isSwipe === true)
            this.onSwipeLeft.emit(this.slideIndex);
        else
            this.onSlideLeft.emit(this.slideIndex);
        this.slides[this.getLeftSideIndex(oldIndex)].leftSide = false;
        this.slides[oldIndex].leftSide = true;
        this.slides[oldIndex].action = 'slideOutLeft';
        this.slides[this.slideIndex].rightSide = false;
        this.slides[this.getRightSideIndex()].rightSide = true;
        this.slides[this.slideIndex].action = 'slideInRight';
    }
    /**
     * \@description This function handles the variables to move the CSS classes around accordingly.
     *              In order to correctly handle animations, the new slide as well as the slides to
     *              the left and right are assigned classes.
     * @param {?} oldIndex
     * @param {?=} isSwipe
     * @return {?}
     */
    slideRight(oldIndex, isSwipe) {
        if (this.debug === true)
            console.log(`slideRight(${oldIndex}, ${isSwipe})`);
        if (isSwipe === true)
            this.onSwipeRight.emit(this.slideIndex);
        else
            this.onSlideRight.emit(this.slideIndex);
        this.slides[this.getRightSideIndex(oldIndex)].rightSide = false;
        this.slides[oldIndex].rightSide = true;
        this.slides[oldIndex].action = 'slideOutRight';
        this.slides[this.slideIndex].leftSide = false;
        this.slides[this.getLeftSideIndex()].leftSide = true;
        this.slides[this.slideIndex].action = 'slideInLeft';
    }
    /**
     * \@description Check to make sure slide images have been set or haven't changed
     * @return {?}
     */
    setSlides() {
        if (this.debug === true)
            console.log(`setSlides()`);
        if (this.initial === true || this.urlCache !== this.imageUrls) {
            if (this.debug === true) {
                console.log(`initial === true || this.urlCache !== this.imageUrls`);
                console.log(`this.initial: ${this.initial}`);
                console.log(`this.urlCache: ${this.urlCache}`);
                console.log(`this.imageUrls: ${this.imageUrls}`);
            }
            this.initial = false;
            this.urlCache = this.imageUrls;
            this.slides = [];
            for (let /** @type {?} */ url of this.imageUrls)
                this.slides.push({
                    url: url,
                    action: '',
                    leftSide: false,
                    rightSide: false,
                    selected: false
                });
            this.slides[this.slideIndex].selected = true;
        }
    }
    /**
     * \@description Start or stop autoPlay, don't do it at all server side
     * @param {?=} stopAutoPlay
     * @return {?}
     */
    handleAutoPlay(stopAutoPlay) {
        if (isPlatformServer(this.platform_id))
            return;
        if (stopAutoPlay === true || this.autoPlay === false) {
            if (this.debug === true)
                console.log(`stop autoPlay`);
            if (!isNullOrUndefined(this.autoplayIntervalId))
                clearInterval(this.autoplayIntervalId);
        }
        else if (isNullOrUndefined(this.autoplayIntervalId)) {
            if (this.debug === true)
                console.log(`start autoPlay`);
            this.autoplayIntervalId = setInterval(() => {
                if (this.debug === true)
                    console.log(`autoPlay slide event`);
                this.slide(1);
            }, this.autoPlayInterval);
        }
    }
    /**
     * \@description Keep the styles up to date with the input
     * @return {?}
     */
    setStyles() {
        if (this.debug === true)
            console.log(`setStyles()`);
        if (!isNullOrUndefined(this.height))
            this.renderer.setStyle(this.container.nativeElement, 'height', this.height);
        if (!isNullOrUndefined(this.minHeight))
            this.renderer.setStyle(this.container.nativeElement, 'min-height', this.minHeight);
        if (!isNullOrUndefined(this.arrowSize)) {
            this.renderer.setStyle(this.prevArrow.nativeElement, 'height', this.arrowSize);
            this.renderer.setStyle(this.prevArrow.nativeElement, 'width', this.arrowSize);
            this.renderer.setStyle(this.nextArrow.nativeElement, 'height', this.arrowSize);
            this.renderer.setStyle(this.nextArrow.nativeElement, 'width', this.arrowSize);
        }
    }
    /**
     * \@description get the index for the slide to the left of the new slide
     * @param {?=} i
     * @return {?}
     */
    getLeftSideIndex(i) {
        if (isUndefined(i))
            i = this.slideIndex;
        if (--i < 0)
            i = this.slides.length - 1;
        return i;
    }
    /**
     * \@description get the index for the slide to the right of the new slide
     * @param {?=} i
     * @return {?}
     */
    getRightSideIndex(i) {
        if (isUndefined(i))
            i = this.slideIndex;
        if (++i >= this.slides.length)
            i = 0;
        return i;
    }
}
SlideshowComponent.ɵfac = function SlideshowComponent_Factory(t) { return new (t || SlideshowComponent)(ɵngcc0.ɵɵdirectiveInject(SwipeService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(PLATFORM_ID)); };
SlideshowComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SlideshowComponent, selectors: [["slideshow"]], viewQuery: function SlideshowComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 1);
        ɵngcc0.ɵɵviewQuery(_c1, 1);
        ɵngcc0.ɵɵviewQuery(_c2, 1);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.container = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.prevArrow = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.nextArrow = _t.first);
    } }, inputs: { showArrows: "showArrows", disableSwiping: "disableSwiping", autoPlay: "autoPlay", autoPlayInterval: "autoPlayInterval", stopAutoPlayOnSlide: "stopAutoPlayOnSlide", debug: "debug", backgroundSize: "backgroundSize", backgroundPosition: "backgroundPosition", backgroundRepeat: "backgroundRepeat", showDots: "showDots", imageUrls: "imageUrls", height: "height", minHeight: "minHeight", arrowSize: "arrowSize" }, outputs: { onSlideLeft: "onSlideLeft", onSlideRight: "onSlideRight", onSwipeLeft: "onSwipeLeft", onSwipeRight: "onSwipeRight" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 12, vars: 6, consts: [[1, "slideshow-container", 3, "touchstart", "touchend"], ["container", ""], ["class", "slides", 3, "ngStyle", "selected", "hide-slide", "left-side", "right-side", "slide-in-left", "slide-in-right", "slide-out-left", "slide-out-right", 4, "ngFor", "ngForOf"], [1, "arrow-container", "prev", 3, "click"], ["title", "Previous", 1, "arrow", "prev"], ["prevArrow", ""], [1, "arrow-container", "next", 3, "click"], ["title", "Next", 1, "arrow", "next"], ["nextArrow", ""], ["class", "slick-dots", 4, "ngIf"], [1, "slides", 3, "ngStyle"], [1, "slick-dots"], [3, "slick-active", "click", 4, "ngFor", "ngForOf"], [3, "click"], ["type", "button"]], template: function SlideshowComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0, 1);
        ɵngcc0.ɵɵlistener("touchstart", function SlideshowComponent_Template_div_touchstart_0_listener($event) { return ctx.onSwipe($event, "start"); })("touchend", function SlideshowComponent_Template_div_touchend_0_listener($event) { return ctx.onSwipe($event, "end"); });
        ɵngcc0.ɵɵtemplate(2, SlideshowComponent_div_2_Template, 1, 22, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵlistener("click", function SlideshowComponent_Template_div_click_3_listener() { return ctx.onSlide(-1); });
        ɵngcc0.ɵɵelementStart(4, "i", 4, 5);
        ɵngcc0.ɵɵtext(6, "\u00AB previous");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 6);
        ɵngcc0.ɵɵlistener("click", function SlideshowComponent_Template_div_click_7_listener() { return ctx.onSlide(1); });
        ɵngcc0.ɵɵelementStart(8, "i", 7, 8);
        ɵngcc0.ɵɵtext(10, "next \u00BB");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(11, SlideshowComponent_ul_11_Template, 2, 1, "ul", 9);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.slides);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("display-none", !ctx.showArrows);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵclassProp("display-none", !ctx.showArrows);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showDots);
    } }, directives: [ɵngcc1.NgForOf, ɵngcc1.NgIf, ɵngcc1.NgStyle], styles: [".display-none[_ngcontent-%COMP%] {\n      display: none !important; }\n\n    .slideshow-container[_ngcontent-%COMP%] {\n      position: relative;\n      display: block;\n      margin: auto;\n      height: 100%;\n      width: 100%;\n      overflow: hidden; }\n      .slideshow-container[_ngcontent-%COMP%]   .hide-slide[_ngcontent-%COMP%] {\n        visibility: hidden;\n        position: absolute;\n        top: -100vw;\n        left: -100vw;\n        opacity: 0; }\n      .slideshow-container[_ngcontent-%COMP%]   .slides[_ngcontent-%COMP%] {\n        position: absolute;\n        top: 0;\n        height: 100%;\n        width: 100%;\n        visibility: visible;\n        opacity: 1; }\n        .slideshow-container[_ngcontent-%COMP%]   .slides.selected[_ngcontent-%COMP%] {\n          left: 0; }\n        .slideshow-container[_ngcontent-%COMP%]   .slides.left-slide[_ngcontent-%COMP%] {\n          left: -100%; }\n        .slideshow-container[_ngcontent-%COMP%]   .slides.right-slide[_ngcontent-%COMP%] {\n          left: 100%; }\n        .slideshow-container[_ngcontent-%COMP%]   .slides.slide-in-left[_ngcontent-%COMP%] {\n          left: 0;\n          -webkit-animation: slideInLeft 0.5s cubic-bezier(0.42, 0, 0.58, 1);\n                  animation: slideInLeft 0.5s cubic-bezier(0.42, 0, 0.58, 1); }\n        .slideshow-container[_ngcontent-%COMP%]   .slides.slide-in-right[_ngcontent-%COMP%] {\n          left: 0;\n          -webkit-animation: slideInRight 0.5s cubic-bezier(0.42, 0, 0.58, 1);\n                  animation: slideInRight 0.5s cubic-bezier(0.42, 0, 0.58, 1); }\n        .slideshow-container[_ngcontent-%COMP%]   .slides.slide-out-left[_ngcontent-%COMP%] {\n          left: -100%;\n          -webkit-animation: slideOutLeft 0.5s cubic-bezier(0.42, 0, 0.58, 1);\n                  animation: slideOutLeft 0.5s cubic-bezier(0.42, 0, 0.58, 1); }\n        .slideshow-container[_ngcontent-%COMP%]   .slides.slide-out-right[_ngcontent-%COMP%] {\n          left: 100%;\n          -webkit-animation: slideOutRight 0.5s cubic-bezier(0.42, 0, 0.58, 1);\n                  animation: slideOutRight 0.5s cubic-bezier(0.42, 0, 0.58, 1); }\n      .slideshow-container[_ngcontent-%COMP%]   .arrow-container[_ngcontent-%COMP%] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center;\n        -webkit-box-pack: center;\n            -ms-flex-pack: center;\n                justify-content: center;\n        position: absolute;\n        top: 0;\n        height: 100%;\n        width: auto;\n        cursor: pointer;\n        background-size: 100%;\n        background-image: -webkit-gradient(linear, left top, left bottom, from(transparent), to(transparent));\n        background-image: linear-gradient(transparent, transparent);\n        z-index: 100;\n        -webkit-user-select: none;\n           -moz-user-select: none;\n            -ms-user-select: none;\n                user-select: none; }\n        .slideshow-container[_ngcontent-%COMP%]   .arrow-container[_ngcontent-%COMP%]:before {\n          display: block;\n          height: 100%;\n          position: absolute;\n          top: 0;\n          left: 0;\n          opacity: 0;\n          width: 100%;\n          z-index: -100;\n          -webkit-transition: opacity 0.45s;\n          transition: opacity 0.45s; }\n        .slideshow-container[_ngcontent-%COMP%]   .arrow-container.prev[_ngcontent-%COMP%] {\n          left: 0; }\n          .slideshow-container[_ngcontent-%COMP%]   .arrow-container.prev[_ngcontent-%COMP%]:before {\n            background-image: -webkit-gradient(linear, right top, left top, from(transparent), to(rgba(0, 0, 0, 0.75)));\n            background-image: linear-gradient(to left, transparent, rgba(0, 0, 0, 0.75));\n            content: ''; }\n        .slideshow-container[_ngcontent-%COMP%]   .arrow-container.next[_ngcontent-%COMP%] {\n          right: 0; }\n          .slideshow-container[_ngcontent-%COMP%]   .arrow-container.next[_ngcontent-%COMP%]:before {\n            background-image: -webkit-gradient(linear, left top, right top, from(transparent), to(rgba(0, 0, 0, 0.75)));\n            background-image: linear-gradient(to right, transparent, rgba(0, 0, 0, 0.75));\n            content: ''; }\n        .slideshow-container[_ngcontent-%COMP%]   .arrow-container[_ngcontent-%COMP%]   .arrow[_ngcontent-%COMP%] {\n          display: block;\n          margin: auto;\n          width: 30px;\n          height: 30px;\n          background: transparent;\n          text-indent: -9999px;\n          border-top: 2px solid #f2f2f2;\n          border-left: 2px solid #f2f2f2;\n          -webkit-transition: all .3s ease-in-out;\n          transition: all .3s ease-in-out;\n          text-decoration: none;\n          color: transparent;\n          -webkit-user-select: none;\n             -moz-user-select: none;\n              -ms-user-select: none;\n                  user-select: none; }\n          .slideshow-container[_ngcontent-%COMP%]   .arrow-container[_ngcontent-%COMP%]   .arrow[_ngcontent-%COMP%]:before {\n            display: block;\n            height: 200%;\n            width: 200%;\n            margin-left: -50%;\n            margin-top: -50%;\n            content: \"\";\n            -webkit-transform: rotate(45deg);\n                    transform: rotate(45deg); }\n          .slideshow-container[_ngcontent-%COMP%]   .arrow-container[_ngcontent-%COMP%]   .arrow.prev[_ngcontent-%COMP%] {\n            -webkit-transform: rotate(-45deg);\n                    transform: rotate(-45deg);\n            position: relative;\n            left: 20px;\n            margin-right: 10px; }\n          .slideshow-container[_ngcontent-%COMP%]   .arrow-container[_ngcontent-%COMP%]   .arrow.next[_ngcontent-%COMP%] {\n            -webkit-transform: rotate(135deg);\n                    transform: rotate(135deg);\n            position: relative;\n            right: 20px;\n            margin-left: 10px; }\n      .slideshow-container[_ngcontent-%COMP%]   .slick-dots[_ngcontent-%COMP%] {\n        display: block;\n        bottom: 15px;\n        z-index: 1;\n        text-align: center;\n        position: absolute;\n        padding: 0;\n        left: 0;\n        right: 0;\n        margin: 0 auto; }\n        .slideshow-container[_ngcontent-%COMP%]   .slick-dots[_ngcontent-%COMP%]   li[_ngcontent-%COMP%] {\n          display: inline;\n          margin: 0;\n          padding: 0; }\n          .slideshow-container[_ngcontent-%COMP%]   .slick-dots[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   button[_ngcontent-%COMP%] {\n            border: none;\n            background: none;\n            text-indent: -9999px;\n            font-size: 0;\n            width: 20px;\n            height: 20px;\n            outline: none;\n            position: relative;\n            z-index: 1;\n            cursor: pointer; }\n            .slideshow-container[_ngcontent-%COMP%]   .slick-dots[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:before {\n              content: '';\n              width: 4px;\n              height: 4px;\n              background: #fff;\n              border-radius: 4px;\n              display: block;\n              position: absolute;\n              top: 50%;\n              left: 50%;\n              -webkit-transform: translate(-50%, -50%);\n                      transform: translate(-50%, -50%);\n              opacity: .7;\n              -webkit-transition: all .5s ease-out;\n              transition: all .5s ease-out; }\n          .slideshow-container[_ngcontent-%COMP%]   .slick-dots[_ngcontent-%COMP%]   li.slick-active[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:before {\n            -webkit-transform: translate(-50%, -50%) scale(1.4);\n                    transform: translate(-50%, -50%) scale(1.4);\n            opacity: 1; }\n\n    @media screen and (min-width: 768px) {\n      .slideshow-container[_ngcontent-%COMP%]   .arrow-container[_ngcontent-%COMP%]:hover:before {\n        opacity: 1; }\n      .slideshow-container[_ngcontent-%COMP%]   .arrow-container[_ngcontent-%COMP%]:hover   .arrow[_ngcontent-%COMP%] {\n        border-width: 4px; }\n      .slideshow-container[_ngcontent-%COMP%]   .arrow-container[_ngcontent-%COMP%]   .arrow[_ngcontent-%COMP%]:hover {\n        border-width: 4px; } }\n\n    @-webkit-keyframes slideInRight {\n      0% {\n        left: -100%; }\n      100% {\n        left: 0; } }\n\n    @keyframes slideInRight {\n      0% {\n        left: -100%; }\n      100% {\n        left: 0; } }\n\n    @-webkit-keyframes slideInLeft {\n      0% {\n        left: 100%; }\n      100% {\n        left: 0; } }\n\n    @keyframes slideInLeft {\n      0% {\n        left: 100%; }\n      100% {\n        left: 0; } }\n\n    @-webkit-keyframes slideOutRight {\n      0% {\n        left: 0; }\n      100% {\n        left: -100%; } }\n\n    @keyframes slideOutRight {\n      0% {\n        left: 0; }\n      100% {\n        left: -100%; } }\n\n    @-webkit-keyframes slideOutLeft {\n      0% {\n        left: 0; }\n      100% {\n        left: 100%; } }\n\n    @keyframes slideOutLeft {\n      0% {\n        left: 0; }\n      100% {\n        left: 100%; } }"] });
/**
 * @nocollapse
 */
SlideshowComponent.ctorParameters = () => [
    { type: SwipeService, },
    { type: Renderer2, },
    { type: undefined, decorators: [{ type: Inject, args: [PLATFORM_ID,] },] },
];
SlideshowComponent.propDecorators = {
    'imageUrls': [{ type: Input },],
    'height': [{ type: Input },],
    'minHeight': [{ type: Input },],
    'arrowSize': [{ type: Input },],
    'showArrows': [{ type: Input },],
    'disableSwiping': [{ type: Input },],
    'autoPlay': [{ type: Input },],
    'autoPlayInterval': [{ type: Input },],
    'stopAutoPlayOnSlide': [{ type: Input },],
    'debug': [{ type: Input },],
    'backgroundSize': [{ type: Input },],
    'backgroundPosition': [{ type: Input },],
    'backgroundRepeat': [{ type: Input },],
    'showDots': [{ type: Input },],
    'onSlideLeft': [{ type: Output, args: ['onSlideLeft',] },],
    'onSlideRight': [{ type: Output, args: ['onSlideRight',] },],
    'onSwipeLeft': [{ type: Output, args: ['onSwipeLeft',] },],
    'onSwipeRight': [{ type: Output, args: ['onSwipeRight',] },],
    'container': [{ type: ViewChild, args: ['container',] },],
    'prevArrow': [{ type: ViewChild, args: ['prevArrow',] },],
    'nextArrow': [{ type: ViewChild, args: ['nextArrow',] },],
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SlideshowComponent, [{
        type: Component,
        args: [{
                selector: 'slideshow',
                template: `
    <div #container
         (touchstart)="onSwipe($event, 'start')"
         (touchend)="onSwipe($event, 'end')"
         class="slideshow-container">
      <!-- slides -->
      <div *ngFor="let slide of slides"
           [ngStyle]="{
              'background-image': 'url('+slide.url+')',
              'background-size': backgroundSize,
              'background-position': backgroundPosition,
              'background-repeat': backgroundRepeat
           }"
           class="slides"
           [class.selected]="slide.selected"
           [class.hide-slide]="!slide.selected && !slide.leftSide && !slide.rightSide"
           [class.left-side]="slide.leftSide"
           [class.right-side]="slide.rightSide"
           [class.slide-in-left]="slide.action === 'slideInLeft'"
           [class.slide-in-right]="slide.action === 'slideInRight'"
           [class.slide-out-left]="slide.action === 'slideOutLeft'"
           [class.slide-out-right]="slide.action === 'slideOutRight'">
      </div>
      <!-- left arrow -->
      <div [class.display-none]="!this.showArrows" (click)="onSlide(-1)" class="arrow-container prev">
        <i #prevArrow title="Previous" class="arrow prev">&laquo; previous</i>
      </div>
      <!-- right arrow -->
      <div [class.display-none]="!this.showArrows" (click)="onSlide(1)" class="arrow-container next">
        <i #nextArrow title="Next" class="arrow next">next &raquo;</i>
      </div>
      <!-- dots -->
      <ul class="slick-dots" *ngIf="showDots">
        <li *ngFor="let slide of slides; let index = index"
            (click)="onButtonClick(index)"
            [class.slick-active]="slide.selected">
          <button type="button">{{index}}</button>
        </li>
      </ul>
    </div>
  `,
                styles: [`
    /*
     styles adapted from https://www.w3schools.com/w3css/4/w3.css
     arrow styles adapted from https://codepen.io/minustalent/pen/Frhaw
     */
    .display-none {
      display: none !important; }

    .slideshow-container {
      position: relative;
      display: block;
      margin: auto;
      height: 100%;
      width: 100%;
      overflow: hidden; }
      .slideshow-container .hide-slide {
        visibility: hidden;
        position: absolute;
        top: -100vw;
        left: -100vw;
        opacity: 0; }
      .slideshow-container .slides {
        position: absolute;
        top: 0;
        height: 100%;
        width: 100%;
        visibility: visible;
        opacity: 1; }
        .slideshow-container .slides.selected {
          left: 0; }
        .slideshow-container .slides.left-slide {
          left: -100%; }
        .slideshow-container .slides.right-slide {
          left: 100%; }
        .slideshow-container .slides.slide-in-left {
          left: 0;
          -webkit-animation: slideInLeft 0.5s cubic-bezier(0.42, 0, 0.58, 1);
                  animation: slideInLeft 0.5s cubic-bezier(0.42, 0, 0.58, 1); }
        .slideshow-container .slides.slide-in-right {
          left: 0;
          -webkit-animation: slideInRight 0.5s cubic-bezier(0.42, 0, 0.58, 1);
                  animation: slideInRight 0.5s cubic-bezier(0.42, 0, 0.58, 1); }
        .slideshow-container .slides.slide-out-left {
          left: -100%;
          -webkit-animation: slideOutLeft 0.5s cubic-bezier(0.42, 0, 0.58, 1);
                  animation: slideOutLeft 0.5s cubic-bezier(0.42, 0, 0.58, 1); }
        .slideshow-container .slides.slide-out-right {
          left: 100%;
          -webkit-animation: slideOutRight 0.5s cubic-bezier(0.42, 0, 0.58, 1);
                  animation: slideOutRight 0.5s cubic-bezier(0.42, 0, 0.58, 1); }
      .slideshow-container .arrow-container {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        -webkit-box-pack: center;
            -ms-flex-pack: center;
                justify-content: center;
        position: absolute;
        top: 0;
        height: 100%;
        width: auto;
        cursor: pointer;
        background-size: 100%;
        background-image: -webkit-gradient(linear, left top, left bottom, from(transparent), to(transparent));
        background-image: linear-gradient(transparent, transparent);
        z-index: 100;
        -webkit-user-select: none;
           -moz-user-select: none;
            -ms-user-select: none;
                user-select: none; }
        .slideshow-container .arrow-container:before {
          display: block;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          opacity: 0;
          width: 100%;
          z-index: -100;
          -webkit-transition: opacity 0.45s;
          transition: opacity 0.45s; }
        .slideshow-container .arrow-container.prev {
          left: 0; }
          .slideshow-container .arrow-container.prev:before {
            background-image: -webkit-gradient(linear, right top, left top, from(transparent), to(rgba(0, 0, 0, 0.75)));
            background-image: linear-gradient(to left, transparent, rgba(0, 0, 0, 0.75));
            content: ''; }
        .slideshow-container .arrow-container.next {
          right: 0; }
          .slideshow-container .arrow-container.next:before {
            background-image: -webkit-gradient(linear, left top, right top, from(transparent), to(rgba(0, 0, 0, 0.75)));
            background-image: linear-gradient(to right, transparent, rgba(0, 0, 0, 0.75));
            content: ''; }
        .slideshow-container .arrow-container .arrow {
          display: block;
          margin: auto;
          width: 30px;
          height: 30px;
          background: transparent;
          text-indent: -9999px;
          border-top: 2px solid #f2f2f2;
          border-left: 2px solid #f2f2f2;
          -webkit-transition: all .3s ease-in-out;
          transition: all .3s ease-in-out;
          text-decoration: none;
          color: transparent;
          -webkit-user-select: none;
             -moz-user-select: none;
              -ms-user-select: none;
                  user-select: none; }
          .slideshow-container .arrow-container .arrow:before {
            display: block;
            height: 200%;
            width: 200%;
            margin-left: -50%;
            margin-top: -50%;
            content: "";
            -webkit-transform: rotate(45deg);
                    transform: rotate(45deg); }
          .slideshow-container .arrow-container .arrow.prev {
            -webkit-transform: rotate(-45deg);
                    transform: rotate(-45deg);
            position: relative;
            left: 20px;
            margin-right: 10px; }
          .slideshow-container .arrow-container .arrow.next {
            -webkit-transform: rotate(135deg);
                    transform: rotate(135deg);
            position: relative;
            right: 20px;
            margin-left: 10px; }
      .slideshow-container .slick-dots {
        display: block;
        bottom: 15px;
        z-index: 1;
        text-align: center;
        position: absolute;
        padding: 0;
        left: 0;
        right: 0;
        margin: 0 auto; }
        .slideshow-container .slick-dots li {
          display: inline;
          margin: 0;
          padding: 0; }
          .slideshow-container .slick-dots li button {
            border: none;
            background: none;
            text-indent: -9999px;
            font-size: 0;
            width: 20px;
            height: 20px;
            outline: none;
            position: relative;
            z-index: 1;
            cursor: pointer; }
            .slideshow-container .slick-dots li button:before {
              content: '';
              width: 4px;
              height: 4px;
              background: #fff;
              border-radius: 4px;
              display: block;
              position: absolute;
              top: 50%;
              left: 50%;
              -webkit-transform: translate(-50%, -50%);
                      transform: translate(-50%, -50%);
              opacity: .7;
              -webkit-transition: all .5s ease-out;
              transition: all .5s ease-out; }
          .slideshow-container .slick-dots li.slick-active button:before {
            -webkit-transform: translate(-50%, -50%) scale(1.4);
                    transform: translate(-50%, -50%) scale(1.4);
            opacity: 1; }

    @media screen and (min-width: 768px) {
      .slideshow-container .arrow-container:hover:before {
        opacity: 1; }
      .slideshow-container .arrow-container:hover .arrow {
        border-width: 4px; }
      .slideshow-container .arrow-container .arrow:hover {
        border-width: 4px; } }

    @-webkit-keyframes slideInRight {
      0% {
        left: -100%; }
      100% {
        left: 0; } }

    @keyframes slideInRight {
      0% {
        left: -100%; }
      100% {
        left: 0; } }

    @-webkit-keyframes slideInLeft {
      0% {
        left: 100%; }
      100% {
        left: 0; } }

    @keyframes slideInLeft {
      0% {
        left: 100%; }
      100% {
        left: 0; } }

    @-webkit-keyframes slideOutRight {
      0% {
        left: 0; }
      100% {
        left: -100%; } }

    @keyframes slideOutRight {
      0% {
        left: 0; }
      100% {
        left: -100%; } }

    @-webkit-keyframes slideOutLeft {
      0% {
        left: 0; }
      100% {
        left: 100%; } }

    @keyframes slideOutLeft {
      0% {
        left: 0; }
      100% {
        left: 100%; } }
  `]
            }]
    }], function () { return [{ type: SwipeService }, { type: ɵngcc0.Renderer2 }, { type: undefined, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }]; }, { showArrows: [{
            type: Input
        }], disableSwiping: [{
            type: Input
        }], autoPlay: [{
            type: Input
        }], autoPlayInterval: [{
            type: Input
        }], stopAutoPlayOnSlide: [{
            type: Input
        }], debug: [{
            type: Input
        }], backgroundSize: [{
            type: Input
        }], backgroundPosition: [{
            type: Input
        }], backgroundRepeat: [{
            type: Input
        }], showDots: [{
            type: Input
        }], onSlideLeft: [{
            type: Output,
            args: ['onSlideLeft']
        }], onSlideRight: [{
            type: Output,
            args: ['onSlideRight']
        }], onSwipeLeft: [{
            type: Output,
            args: ['onSwipeLeft']
        }], onSwipeRight: [{
            type: Output,
            args: ['onSwipeRight']
        }], imageUrls: [{
            type: Input
        }], height: [{
            type: Input
        }], minHeight: [{
            type: Input
        }], arrowSize: [{
            type: Input
        }], container: [{
            type: ViewChild,
            args: ['container']
        }], prevArrow: [{
            type: ViewChild,
            args: ['prevArrow']
        }], nextArrow: [{
            type: ViewChild,
            args: ['nextArrow']
        }] }); })();

class SlideshowModule {
}
SlideshowModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: SlideshowModule });
SlideshowModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function SlideshowModule_Factory(t) { return new (t || SlideshowModule)(); }, providers: [
        SwipeService
    ], imports: [[
            CommonModule
        ]] });
/**
 * @nocollapse
 */
SlideshowModule.ctorParameters = () => [];
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SlideshowModule, { declarations: function () { return [SlideshowComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [SlideshowComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SlideshowModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule
                ],
                declarations: [
                    SlideshowComponent
                ],
                exports: [
                    SlideshowComponent
                ],
                providers: [
                    SwipeService
                ]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { SlideshowModule, SlideshowComponent as ɵa, SwipeService as ɵb };

//# sourceMappingURL=ng-simple-slideshow.js.map